import { defineComponent as _defineComponent } from 'vue'
import FormattedCurrency from './FormattedCurrency.vue';
import SimpleDoughnutChart from 'ah-reports/src/components/SimpleDoughnutChart.vue';
import { BModal } from 'bootstrap-vue';
import { ClientRiskLimitsProfile } from 'ah-api-gateways';
import { VButton, VCol, VRow } from 'ah-common-lib/src/common/components';
import { computed, PropType, ref } from 'vue';
import { formatNumberValue } from 'ah-common-lib/src/helpers/numbers';
import { getChartColorsForProfileUsageLevel } from '../../helpers/chartConfig';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useRouter } from 'vue-router/composables';
import { useTradeState } from 'ah-trades';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradingLimits',
  props: {
  isActiveMarginCall: {
    type: Boolean,
    required: true,
  },
  limitsProfileData: {
    type: Object as PropType<ClientRiskLimitsProfile>,
  },
},
  setup(__props) {

const props = __props;



const router = useRouter();

const requestManager = useRequestManager().manager;

const oboClientId = useOnBehalfOf();

const tradeState = useTradeState();

const confirmNotifyUsModal = ref<InstanceType<typeof BModal> | null>(null);

const thankYouNotifyUsModal = ref<InstanceType<typeof BModal> | null>(null);

const spotsInfo = computed(() => props.limitsProfileData ? [
  { label: 'Total Limit', value: props.limitsProfileData.notionalLimitSpots },
  { label: 'Utilised Limit', value: props.limitsProfileData.notionalLimitSpotsInUse },
  { label: 'Remaining Limit', value: props.limitsProfileData.notionalLimitSpotsRemaining },
] : []);

const forwardsAndOptionsInfo = computed(() => props.limitsProfileData ? [
  { label: 'Total Limit', value: props.limitsProfileData.notionalLimitForwardsOptions },
  { label: 'Utilised Limit', value: props.limitsProfileData.notionalLimitForwardsOptionsInUse },
  { label: 'Remaining Limit', value: props.limitsProfileData.notionalLimitForwardsOptionsRemaining },
] : []);

function confirmNotifyUs() {
  confirmNotifyUsModal.value?.show();
}

function onConfirmNotify() {
  requestManager.currentOrNew('requestNotify', tradeState.services.limits.notifyUsLimit()).subscribe(() => {
    thankYouNotifyUsModal.value?.show();
  });
}

function goToCreditAndMTMPage() {
  if (oboClientId.value?.id) {
    router.push('/admin/activity/clients/5545e986-868f-428d-bda2-7f6f70d237ff/credit-mtm');
  } else {
    router.push('/dashboard/trades/credit-mtm');
  }
}

return { __sfc: true,props, router, requestManager, oboClientId, tradeState, confirmNotifyUsModal, thankYouNotifyUsModal, spotsInfo, forwardsAndOptionsInfo, confirmNotifyUs, onConfirmNotify, goToCreditAndMTMPage, FormattedCurrency, SimpleDoughnutChart, BModal, VButton, VCol, VRow, formatNumberValue, getChartColorsForProfileUsageLevel }
}

})